import { RecordPageRenderContext } from "../../../../types";
import { SetupInformation } from "../../../../utils/styled";

export function renderSetupInfo(ctx: RecordPageRenderContext): JSX.Element {
  if (ctx.setupMode === "DASHBOARD_TABBED_SETUP") {
    return (
      <SetupInformation>
        <b>{ctx.title}</b>
        <p>{ctx.description}</p>
      </SetupInformation>
    );
  }

  return <></>;
}
